import React from 'react'
import Dashnav from '../Components/Dashnav'
import Leftmenu from '../Components/Leftmenu'
import StartupComp from './StartupComp'

function MyStartups() {
  return (
    <div>
        <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <StartupComp/>
            </div>
        </div>  
    </div>
  )
}

export default MyStartups